module.exports = __webpack_public_path__ + "img/home-banner-01.1be3a0cd.jpg";